import * as React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { FieldProps, generateValidations } from '../../../core/form';
import ColumnContainer from './ColumnContainer';
import { otherFieldName } from '../../../core/constants';

const DragAndDropQuestion = (props: Props) => {
	const { name, data, sourceColumnTitle, destinationColumnTitle } = props;
	const { setValue } = useFormContext();
	const { field } = useController({ name, rules: generateValidations(props) });
	const { value } = field;

	return (
		<ColumnContainer
			specData={data}
			selectedValue={value}
			onDragEnd={(newValue: string) => setValue(name, newValue)}
			onValueChange={(newValue: string) => setValue(otherFieldName, newValue)}
			sourceColumnTitle={sourceColumnTitle}
			destinationColumnTitle={destinationColumnTitle}
		/>
	);
};

export default DragAndDropQuestion;

interface Props extends FieldProps {
	sourceColumnTitle: string;
	destinationColumnTitle: string;
}
